import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import { toast } from "react-toastify";
import { CommonModal } from "./CommonModal";
import { ClientLogTable } from "./clientlogs/Table";
import { getRecentQuotes, getRecentQuotesArray } from "../store/components";
import {
  addTransaction,
  getTransactions,
  getTransactionsInformation,
} from "../store/transactions";
import {
  getMyQuotes,
  getRowDetailsFromProspectId,
  getClientDetailsUsingProspectId,
} from "../store/myquotes";
import Loader3Orange from "../general/Loader3Orange";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
} from "../store/quotes";
import { getIsBpSuccess, updateBmsInfo, updateOwner, updateProspectStatus } from "../store/qf";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NormalText from "../general/NormalText";
import { PossibleClientDetailsStatus } from "../store/helperfuncs";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import { Button, TextareaAutosize, TextField } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import ActionButton from "../general/ActionButton";
import Select from "react-dropdown-select";
import ActionCentreText from "../general/ActionCetreText";
import ActionMessageButton from "../general/ActionMessageButton";
import { capitalizeFirstLetter } from "../utils/utils";
import TruncatedText from "../general/TruncatedText";
import { useNavigate } from "react-router-dom";
import { getUserDetails, getUserInformation } from "../store/userManagement";
import axios from "axios";
import { getBrokerInformation } from "../store/broker";
import "moment/locale/fr"; // Import French locale data
import externalTranslations from "../utils/translations";
const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);
const translations = {
  en: {
    followUp: "Follow-up:",
    form: {
      generalBindInformation: "General Bind Information",
      financials: "Financials",
      insurerLabel: "Insurer *",
      bindNumberLabel: "Bind Number",
      quoteReferenceLabel: "Quote Reference *",
      effectiveDateLabel: "Effective Date",
      expiryDateLabel: "Expiry Date *",
      paymentMethodLabel: "Payment Method *",
      premiumLabel: "Premium",
      insurerFeesLabel: "Insurer Fees *",
      brokerFeesLabel: "Broker Fees",
      premiumAndFeesLabel: "Premium & Fees *",
      taxRateApplicableLabel: "Tax rate applicable (%)",
      taxesPayableLabel: "Taxes payable",
      commissionRateLabel: "Commission rate (%)",
      commissionEarnedLabel: "Commission earned",
      selectPaymentMethodPlaceholder: "Select a payment method",
      prospectInformation: "Prospect Information",
      clientName: "Client Name",
      contactName: "Contact Name",
      vertical: "Vertical",
      contactNumber: "Contact Number",
      brokerOwner: "Broker Owner",
      contactEmail: "Contact Email",
      filters: "Filters",
      date: "Date",
      status: "Status",
      clearFilters: "Clear Filters",
      searchForClient: "Search for a Client",
      transactionHistory: "Transaction History",
      user: "User",
      type: "Type",
      comments: "Comments",
      download: "Download",

      // Add more form-related translations as needed
    },
    actions: {
      addComments: {
        text: "Add comments or other information to this prospect file",
        buttonText: "Add Comment",
      },
      checkInsurerResponses: {
        text: "Check to see how insurers are responding to any applications sent out",
        buttonText: "Digital Marketing Hub",
      },
      continueAmendProspect: {
        text: "Continue where you left off or amend prospect information for quotations",
        buttonText: "Go to Application",
      },
      closeProspect: {
        text: "Close this prospect for now, but set-up a review next year",
        buttonText: "Update Status",
      },
    },

    modal: {
      normalText: {
        selectStatusAndComment: "Please select a status and enter comment",
        enterComment: "Please enter a comment",
      },
      selectStatusPlaceholder: "Select a status",
      textareaPlaceholder: "Enter a comment",
      actionButtons: {
        save: "Save",
        cancel: "Cancel",
      },
    },
  },
  fr: {
    followUp: "Suivi :",
    form: {
      generalBindInformation: "Informations Générales de Liaison",
      financials: "Financiers",
      insurerLabel: "Assureur *",
      bindNumberLabel: "Numéro de Liaison",
      quoteReferenceLabel: "Référence de Devis *",
      effectiveDateLabel: "Date effective",
      expiryDateLabel: "Date d'Expiration *",
      paymentMethodLabel: "Méthode de Paiement *",
      premiumLabel: "Prime",
      insurerFeesLabel: "Frais de l'Assureur *",
      brokerFeesLabel: "Frais de Courtier",
      premiumAndFeesLabel: "Prime & Frais *",
      taxRateApplicableLabel: "Taux de taxe applicable (%)",
      taxesPayableLabel: "Taxes Payables",
      commissionRateLabel: "Taux de Commission (%)",
      commissionEarnedLabel: "Commission Gagnée",
      selectPaymentMethodPlaceholder: "Sélectionnez une méthode de paiement",
      prospectInformation: "Informations sur le client potentiel",
      clientName: "Nom du Client",
      contactName: "Nom du Contact",
      vertical: "Secteur d’activités​",
      contactNumber: "Téléphone du contact",
      brokerOwner: "Courtier",
      contactEmail: "Courriel du contact",
      filters: "Filtres",
      date: "Date",
      status: "STATUT",
      clearFilters: "Effacer les Filtres",
      searchForClient: "Rechercher un Client",
      transactionHistory: "Historique des transactions",
      user: "Utilisateur",
      type: "Statut",
      comments: "Commentaires",
      download: "Téléchargement",
      // Add more form-related translations as needed
    },

    actions: {
      addComments: {
        text: "Ajouter des commentaires ou d'autres informations à ce dossier de client potentiel​",
        buttonText: "Ajouter un Commentaire",
      },
      checkInsurerResponses: {
        text: "Centre de suivi des demandes transmises aux assureurs​",
        buttonText: "Plate-forme numérique",
      },
      continueAmendProspect: {
        text: "Compléter votre demande de soumission ou apporter des modifications",
        buttonText: "Réviser / Poursuivre",
      },
      closeProspect: {
        text: "Fermer la demande de soumission pour cette année mais reporter à l'an prochain​",
        buttonText: "Mettre à jour le statut",
      },
    },

    modal: {
      normalText: {
        selectStatusAndComment:
          "Veuillez sélectionner un statut et entrer un commentaire",
        enterComment: "Veuillez entrer un commentaire",
      },
      selectStatusPlaceholder: "Sélectionnez un statut",
      textareaPlaceholder: "Entrez un commentaire",
      actionButtons: {
        save: "Enregistrer",
        cancel: "Annuler",
      },
    },
  },
};
const statusTranslations = {
  New: {
    fr: "Nouveau",
  },
  "App In Progress": {
    fr: "En cours",
  },
  "Close - Incomplete info": {
    fr: "Fermé - Informations incomplètes",
  },
  "App Completed": {
    fr: "Application terminée",
  },
  "In Market": {
    fr: "Sur le marché",
  },
  "Close - No Insurer": {
    fr: "Fermé - Aucun assureur",
  },
  Quoted: {
    fr: "Devis fourni",
  },
  "Not Interested": {
    fr: "Pas intéressé",
  },
  Sold: {
    fr: "Vendu",
  },
  "Send to Market": {
    fr: " Envoyer au marché ",
  },
  "Continued Quote": {
    fr: "Suite du devis ",
  },
  "Client Presentation": {
    fr: "Présentation client ",
  },
  "Quote received": {
    fr: "Devis reçu ",
  },
  "Client adjustments": {
    fr: "Ajustements clients ",
  },
  "Added Insurer": {
    fr: "Assureur ajouté ",
  },
};

// Helper function to translate auto-generated comments
const getTranslatedComment = (comment, languageCode) => {
  if (!comment) return '';
  const translatedComment = externalTranslations[languageCode]?.transactionData?.autoComments?.[comment];
  return translatedComment || comment;
};

const ProspectZoom = () => {
  const dispatch = useDispatch();
  const search = useLocation().search;
  var code = new URLSearchParams(search).get("id");

  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.myquotes })
    );
    console.log("Prosepct Zoom, getQuotes");
    dispatch(getMyQuotes({ prospect_id: code }));
    //need to speed up this dispatch
  }, [dispatch]);
  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        <TwoPanesPanel
          myquotesscreen={true}
          myquotesleftpane={
            <ProspectZoomLeftPane prospectid={code}></ProspectZoomLeftPane>
          }
          myquotesrightpane={
            <ProspectZoomRightPane prospectid={code}></ProspectZoomRightPane>
          }
        ></TwoPanesPanel>
      </MainPane>
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const ProspectZoomLeftPane = (props) => {
  const dispatch = useDispatch();
  let prospectid = props.prospectid;
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";
  useEffect(() => {
    if (
      prospectDetails &&
      prospectDetails.clientdetails === PossibleClientDetailsStatus.notstarted
    )
      dispatch(getClientDetailsUsingProspectId({ prospectid }));
  });
  function translateStatus(status, langPref) {
    if (statusTranslations[status] && statusTranslations[status][langPref]) {
      return statusTranslations[status][langPref];
    } else if ( langPref == "fr" ) {
      // Handle cases where the status or language preference is not found
      console.warn(
        `No translation found for status "${status}" and language "${langPref}". Returning original status.`
      );
    }
    return status; // Or you could return a default translation
  }
  let heightDivison = {
    backtoapp: "1%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "1vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const navigate = useNavigate();

  return (
    <div>
      <div style={{ marginLeft: "5%", marginTop: "2px" }}>
        <BackToApplication
          text={translations[languagecode].backToProspects}
          onClick={() => {
            //document.location.href = `/myquotes`;
            //navigate(`/myquotes`);
            navigate(-1);
          }}
        ></BackToApplication>
      </div>
      <div style={{ display: "flex" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: "5vmin",
            marginLeft: "100px",
            marginTop: "25px",
            color: theme.COLORS.primary_navyblue,
          }}
        >
          {/* Prospect Information */}
          {translations[languagecode]?.form.prospectInformation}
        </Typography>
        <div
          style={{
            fontSize: "2vmin",
            marginLeft: "20px",
            marginTop: "40px",
            marginBottom: "25px",
            backgroundColor: theme.COLORS.secondary_orange,
            borderRadius: "20px",
          }}
        >
          <Typography
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "2vmin",
              marginLeft: "15px",
              marginRight: "15px",
              color: "white",
              textTransform: "capitalize",
            }}
          >
            {prospectDetails
              ? translateStatus(prospectDetails.status, languagecode)
              : "-"}
          </Typography>
        </div>
        <div
          style={{
            fontSize: "2vmin",
            marginLeft: "20px",
            marginTop: "40px",
            marginBottom: "25px",
            backgroundColor: theme.COLORS.secondary_skyblue,
            borderRadius: "20px",
          }}
        >
          <FormatDateTitle
            d={prospectDetails ? prospectDetails.lastupdated : new Date()}
          ></FormatDateTitle>
        </div>
      </div>
      <form className="my-2" style={{ width: "100%" }}>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label text-secondary">
            {/* Client Name */}
            {translations[languagecode]?.form.clientName}
          </label>
          <label className="col-sm-3 col-form-label">
            {prospectDetails && prospectDetails.clientdetails
              ? prospectDetails.clientdetails["CLIENT_NAME"]
              : "-"}
          </label>

          <label className="col-sm-2 col-form-label text-secondary">
            {/* Contact Name */}
            {translations[languagecode]?.form.contactName}
          </label>
          <label className="col-sm-3 col-form-label">
            {prospectDetails && prospectDetails.clientdetails
              ? prospectDetails.clientdetails["CLIENT_BUSINESS_NAME"]
              : "-"}
          </label>
        </div>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          <label className="col-sm-2 col-form-label text-secondary">
            {/* Vertical */}
            {translations[languagecode]?.form.vertical}
          </label>
          <label className="col-sm-3 col-form-label">
            {prospectDetails && prospectDetails.vertical
              ? prospectDetails.vertical[languagecode]
              : "-"}
          </label>

          <label className="col-sm-2 col-form-label  text-secondary">
            {/* Contact Number */}
            {translations[languagecode]?.form.contactNumber}
          </label>
          <a
            className="col-sm-3 col-form-label"
            href={
              "tel:" +
              (prospectDetails && prospectDetails.clientdetails
                ? prospectDetails.clientdetails["CLIENT_CONTACT"]?.replace(
                    /[^0-9]+/g,
                    ""
                  )
                : "-")
            }
          >
            {prospectDetails && prospectDetails.clientdetails
              ? prospectDetails.clientdetails["CLIENT_CONTACT"]
              : "-"}
          </a>
        </div>
        <div
          className="form-group row"
          style={{
            fontFamily: "GibsonRegular",
            justifyContent: "left",
            fontSize: "0.8vw",
            margin: 0,
            marginLeft: "6%",
          }}
        >
          {/* <label className="col-sm-2 col-form-label  text-secondary">
            
            {translations[languagecode]?.form.brokerOwner}
          </label>
          <label className="col-sm-3 col-form-label">
            {prospectDetails ? prospectDetails.brokername : "-"}
          </label>  */}
          <BrokerOwner prospectDetails={prospectDetails} />
          <label className="col-sm-2 col-form-label  text-secondary">
            {/* Contact Email */}
            {translations[languagecode]?.form.contactEmail}
          </label>
          <a
            className="col-sm-3 col-form-label"
            href={
              "mailto:" +
              (prospectDetails && prospectDetails.clientdetails
                ? prospectDetails.clientdetails["CLIENT_EMAIL"]
                : "-")
            }
          >
            {prospectDetails && prospectDetails.clientdetails
              ? prospectDetails.clientdetails["CLIENT_EMAIL"]
              : "-"}
          </a>
        </div>
      </form>
      <PerfectScrollbar style={{ height: "61vh" }}>
        <LeftPaneGeneral
          heightDivison={heightDivison}
          headingSection={
            <TwoHeading
              heading1={translations[languagecode]?.form.transactionHistory}
              fontSize="4vmin"
              heading2={""}
            ></TwoHeading>
          }
          tableHeaderSection={
            <ProspectZoomTableHeader></ProspectZoomTableHeader>
          }
          tableRowsSection={
            // <div style={{ width: "100%", height: "100vh" }}></div>
            <ProspectZoomRowsSection
              heightDivison={heightDivison}
              prospectid={props.prospectid}
            >
              <ProspectZoomEachRow
                heightDivison={heightDivison}
                mainContMargin={mainContMargin}
              ></ProspectZoomEachRow>
            </ProspectZoomRowsSection>
          }
        ></LeftPaneGeneral>
      </PerfectScrollbar>
    </div>
  );
};

const ProspectZoomRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  useEffect(() => {
    dispatch(getTransactions(props.prospectid));
  }, [dispatch, props.prospectid]);
  const transInfo = useSelector(getTransactionsInformation);
  return (
    <>
      {transInfo ? (
        props.children
      ) : (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      )}
    </>
  );
};

const ProspectZoomEachRow = ({ heightDivison, mainContMargin }) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);

  const transInfo = useSelector(getTransactionsInformation);

  const responsesDiv = useRef(null);
  const dispatch = useDispatch();

  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();

  return (
    <div
      style={{
        width: "100%",
        height: heightDivison.responses,
        paddingLeft: mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {transInfo.map((p, index) => (
          <ProspectRow key={index} prospect={p}></ProspectRow>
        ))}
      </div>
    </div>
  );
};

const getDocument = (docKey) => {
  axios
    .get(
      process.env.REACT_APP_BASICSERVICE +
        "/api/transactions/get-document?key=" +
        docKey,
      {
        headers: { "x-auth-token": localStorage.getItem("jwt") },
      }
    )
    .then((res) => {
      const link = document.createElement("a");
      try {
        link.href = res.data.url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        toast.error("Something went wrong while getting Pdf");
      }
    });
};

function downloadFile(s3Url) {
  fetch(s3Url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.blob();
    })
    .then((blob) => {
      // Create a new object URL for the blob object
      const url = window.URL.createObjectURL(blob);

      // Create a temporary download link
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "downloaded_file.pdf"; // Name of the downloaded file

      // Append the anchor to the body, click it, and remove it
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Clean up by revoking the object URL
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Error downloading the document:", error);
    });
}

const ProspectRow = ({ prospect }) => {
  const statusTranslations = {
    New: {
      fr: "Nouveau",
    },
    "App In Progress": {
      fr: "En cours",
    },
    "Close - Incomplete info": {
      fr: "Fermé - Informations incomplètes",
    },
    "App Completed": {
      fr: "Application terminée",
    },
    "In Market": {
      fr: "Sur le marché",
    },
    "Close - No Insurer": {
      fr: "Fermé - Aucun assureur",
    },
    Quoted: {
      fr: "Devis fourni",
    },
    "Not Interested": {
      fr: "Pas intéressé",
    },
    Sold: {
      fr: "Vendu",
    },
    "Send to Market": {
      fr: " Envoyer au marché ",
    },
    "Continued Quote": {
      fr: "Suite du devis ",
    },
    "Client Presentation": {
      fr: "Présentation client ",
    },
    "Quote received": {
      fr: "Devis reçu ",
    },
    "Client adjustments": {
      fr: "Ajustements clients ",
    },
    "Added Insurer": {
      fr: "Assureur ajouté ",
    },
    "Please review client changes during client hand-off": {
      fr: "Veuillez examiner les modifications du client lors de la remise au client.",
    },
  };

  function translateStatus(status, langPref) {
    if (statusTranslations[status] && statusTranslations[status][langPref]) {
      return statusTranslations[status][langPref];
    } else {
      // Handle cases where the status or language preference is not found
      console.warn(
        `No translation found for status "${status}" and language "${langPref}". Returning original status.`
      );
      return status; // Or you could return a default translation
    }
  }

  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  var pdfDownload = false;
  let longDocNameThreshold = 38;
  var clientChangeLog = false;
  if (prospect.otherDetails && prospect.otherDetails.s3) {
    pdfDownload = true;
  }
  if (prospect.otherDetails?.clientLog) {
    clientChangeLog = true;
  }
  var premium = "";
  if (prospect.otherDetails?.premium) {
    premium =
      "$" +
      Number(Number(prospect.otherDetails?.premium)?.toFixed(2)).toLocaleString(
        "en",
        {
          minimumFractionDigits: 2,
        }
      );
  }
  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };
  var [openModal, setopenModal] = useState(false);
  var defaultRowCSS = {
    height: "50px",
    toStatus: {
      fontSize: "15",
    },
  };
  if (prospect.tostatus?.length > longDocNameThreshold) {
    defaultRowCSS.height = "70px";
    defaultRowCSS.toStatus.fontSize = "small";
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: defaultRowCSS.height,
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: "15%",
          ...borderCommon,
        }}
      >
        {/* <FormateDate d={prospect.usertime}></FormateDate> */}
        <FormattedDate
          milliseconds={prospect.usertime}
          languagepreference={languagepreference}
        ></FormattedDate>
      </div>
      <div
        style={{
          ...commonStyle,
          width: "10%",
          ...borderCommon,
        }}
      >
        <NormalText
          text={prospect.username}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: "15%",
          ...borderCommon,
        }}
      >
        <NormalText
          text={translateStatus(
            capitalizeFirstLetter(prospect.tostatus),
            languagepreference
          )}
          fontSize={defaultRowCSS.toStatus.fontSize} // tostatus
          fontWeight={"normal"}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: "15%",
          ...borderCommon,
        }}
      >
        {/* <FormateDate d={prospect?.otherDetails?.effectiveDate}></FormateDate> */}
        <FormattedDate
          milliseconds={prospect?.otherDetails?.effectiveDate}
          languagepreference={languagepreference}
        ></FormattedDate>
      </div>
      <div
        style={{
          ...commonStyle,
          width: "15%",
          ...borderCommon,
        }}
      >
        <NormalText
          text={premium}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: "20%",
          ...borderCommon,
        }}
      >
        <TruncatedText
          text={getTranslatedComment(
            prospect.comments,
            languagepreference
          )}
          maxLength={20}
          type={prospect?.tostatus}
        />
      </div>
      <div
        style={{
          ...commonStyle,
          width: "10%",
          ...borderCommon,
        }}
      >
        {pdfDownload ? (
          <button
            onClick={async () => {
              if (prospect.otherDetails?.s3?.key)
                getDocument(prospect.otherDetails.s3.key);
              else if (Array.isArray(prospect.otherDetails.s3)) {
                var s3keys = [...prospect.otherDetails.s3];
                var interval = setInterval(download, 600, s3keys);
                function download(s3keys) {
                  var url = s3keys.pop();
                  getDocument(url.key);
                  if (s3keys.length == 0) {
                    clearInterval(interval);
                  }
                }
              } else if (prospect.otherDetails.s3) {
                window.open(prospect.otherDetails.s3);
                // downloadFile(prospect.otherDetails.s3);
              } else {
                toast.error("Something went wrong while getting Pdf");
              }
            }}
          >
            {translations[languagepreference].form.download}
          </button>
        ) : null}
        {clientChangeLog ? (
          <button
            onClick={() => {
              setopenModal(true);
            }}
          >
            {externalTranslations[languagepreference].viewChanges}
          </button>
        ) : null}
        {!pdfDownload && !clientChangeLog && (
          <NormalText
            text={""}
            fontWeight={"normal"}
            fontSize={15}
            color="grey"
          ></NormalText>
        )}
      </div>
      <CommonModal
        modalHeight={"60vh"}
        modalWidth={"45vw"}
        openModalBool={openModal}
        closeModal={() => setopenModal(false)}
        handleSbmtBtn={() => setopenModal(false)}
        buttontxt={externalTranslations[languagepreference].close}
        heading={externalTranslations[languagepreference].clientAnswerLog}
      >
        <ClientLogTable
          languagepreference={languagepreference}
          logs={prospect.otherDetails?.clientLog}
        ></ClientLogTable>
      </CommonModal>
    </div>
  );
};

const FormattedDate = ({ milliseconds, languagepreference }) => {
  // console.log('eurooos',milliseconds)
 
  let date = new Date(milliseconds);
  const [dateFormatted,setDateFormatted] = useState(moment(date)
  .locale(languagepreference)
  .format("DD MMM YYYY h:mma"))

  useEffect(()=>{
    let temp = moment(date)
    .locale(languagepreference)
    .format("DD MMM YYYY h:mma")
    setDateFormatted(temp)
  },[languagepreference])

 if(!milliseconds){
    return <></>
  }
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};

const FormateDate = ({ d }) => {
  let date = new Date(d);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY h:mma");
  if (date == "Invalid Date") {
    dateFormatted = "";
  }
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};

const FormatDateTitle = ({ d }) => {
  let date = new Date(d);
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";
  const [dateFormatted, setDateFormatted] = useState(
    moment(date).locale(languagecode).format("DD MMM YYYY")
  );

  useEffect(() => {
    let temp = moment(date).locale(languagecode).format("DD MMM YYYY");
    setDateFormatted(temp);
  }, [languagecode]);

  return (
    <Typography
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "2vmin",
        marginLeft: "15px",
        marginRight: "15px",
        color: "white",
      }}
    >
      {translations[languagecode]?.followUp} {dateFormatted}
    </Typography>
  );
};

const ProspectZoomTableHeader = (props) => {
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";
  const columnHeadingsQuotes = {
    first: translations[languagecode].form.date,
    second: translations[languagecode].form.user,
    third: translations[languagecode].form.type,
    fourth: translations[languagecode].form.effectiveDateLabel,
    fifth: translations[languagecode].form.premiumLabel,
    sixth: translations[languagecode].form.comments,
    seventh: translations[languagecode].form.download,
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid white`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.primary_navyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: "15%", ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first}
      </div>
      <div style={{ width: "10%", ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second}
      </div>
      <div style={{ width: "15%", ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third}
      </div>
      <div style={{ width: "15%", ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fourth}
      </div>
      <div style={{ width: "15%", ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth}
      </div>
      <div
        style={{
          width: "20%",
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.sixth}
      </div>
      <div
        style={{
          width: "10%",
          ...CommonStyleColumn,
        }}
      >
        {columnHeadingsQuotes.seventh}
      </div>
    </div>
  );
};

const BrokerOwner = ({ prospectDetails, onSave }) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [preventSave, setpreventSave] = useState(true);
  const [brokerName, setBrokerName] = useState(
    prospectDetails?.brokername || "-"
  );
  let userList = useSelector(getUserInformation);
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";

  useEffect(() => {
    // dispatch(getDetails(data))
    console.log(
      `prospectDetails?.brokeragecode: ${prospectDetails?.brokeragecode}`
    );
    dispatch(
      getUserDetails({ brokerage_code: prospectDetails?.brokeragecode })
    );
    if (prospectDetails?.brokername && brokerName == "-") {
      setBrokerName(prospectDetails.brokername);
    }
  }, [dispatch, prospectDetails]);

  const handleEditClick = () => {
    setIsEditing(true);
    setpreventSave(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    let foundUser = userList.find(
      (x) => x?.firstname + " " + x?.lastname == brokerName
    );
    let payload = {
      userid: foundUser._id,
      prospectid: prospectDetails.prospectid,
      newname: brokerName,
      oldname: prospectDetails?.brokername,
    };
    if (onSave) onSave(payload); // Call a save function to handle the new value
    dispatch(updateOwner(payload));
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setBrokerName(prospectDetails?.brokername || "-"); // Reset to the original value
  };

  const handleOnChange = (e, broker, v) => {
    if (v == "clear") {
      setpreventSave(true);
      return;
    }
    let tmpName = `${broker.firstname} ${broker.lastname}`;
    setBrokerName(tmpName);
    setpreventSave(false);
    //let foundUser = userList.find(x => (x?.firstname + " " + x?.lastname) == tmpName);
    //foundUser ? setpreventSave(false) : setpreventSave(true)
  };

  return (
    <>
      {/* <div className="row align-items-center"> */}
      <label className="col-sm-2 col-form-label text-secondary">
        {translations[languagecode]?.form.brokerOwner}
      </label>

      {/* <div className="col-sm-6 d-flex align-items-center"> */}
      {isEditing ? (
        <>
          {/* <input
              list="broker-options"
              className="form-control col-sm-2"
              value={brokerName}
              onChange={(e) => handleOnChange(e)}
            />
            <datalist id="broker-options">
              {userList.map((broker, index) => (
                <option key={index} value={broker.firstname + " " + broker.lastname}   />
              ))}
            </datalist> */}
          <Autocomplete
            className="form-control col-sm-2"
            id={`autocompleteUserList`}
            //options={[]}
            options={userList}
            getOptionLabel={(broker) =>
               broker.firstname + " " + broker.lastname
             }
            onChange={handleOnChange}
            renderInput={(params) => <TextField {...params} />}
          />
          <button
            className="btn btn-primary btn-sm mx-2"
            onClick={handleSaveClick}
            disabled={preventSave}
          >
            {externalTranslations[languagecode].save}
            {/* Save */}
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={handleCancelClick}
          >
            {externalTranslations[languagecode].cancel}
            {/* Cancel */}
          </button>
        </>
      ) : (
        <>
          <div className="col-form-label col-sm-3 ">
            <label>{brokerName}</label>
            <button
              className="btn btn-link btn-sm ms-3"
              onClick={handleEditClick}
            >
              {externalTranslations[languagecode].edit}
              {/* Edit */}
            </button>
          </div>
        </>
      )}
      {/* </div> */}
      {/* </div> */}
    </>
  );
};
//#endregion

//#region Right Pane
const ProspectZoomRightPane = (props) => {
  const [modalState, setModal] = useState(false);
  const [hideStatus, setHideStatus] = useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [comment, setComment] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const prospectid = props.prospectid;
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference || "en";
  const statusOptionLabelTranslations = {
    en: {
      statusNew: "New",
      statusAppInProgress: "App In Progress",
      statusCloseIncompleteInfo: "Close - Incomplete Info",
      statusAppCompleted: "App Completed",
      statusInMarket: "In Market",
      statusCloseNoInsurer: "Close - No Insurer",
      statusQuoted: "Quoted",
      statusNotInterested: "Not Interested",
      statusSold: "Sold",
    },
    fr: {
      statusNew: "Nouveau",
      statusAppInProgress: "Demande en cours",
      statusCloseIncompleteInfo: "Fermé - Informations incomplètes",
      statusAppCompleted: "Demande complétée",
      statusInMarket: "En marché",
      statusCloseNoInsurer: "Fermé - Aucun assureur",
      statusQuoted: "Soumis",
      statusNotInterested: "Pas intéressé",
      statusSold: "Vendu",
    },
  };
  const statusOptions = [
    {
      value: "New",
      label: statusOptionLabelTranslations[languagecode].statusNew,
    },
    {
      value: "App In Progress",
      label: statusOptionLabelTranslations[languagecode].statusAppInProgress,
    },
    {
      value: "Close - Incomplete Info",
      label:
        statusOptionLabelTranslations[languagecode].statusCloseIncompleteInfo,
    },
    {
      value: "App Completed",
      label: statusOptionLabelTranslations[languagecode].statusAppCompleted,
    },
    {
      value: "In Market",
      label: statusOptionLabelTranslations[languagecode].statusInMarket,
    },
    {
      value: "Close - No Insurer",
      label: statusOptionLabelTranslations[languagecode].statusCloseNoInsurer,
    },
    {
      value: "Quoted",
      label: statusOptionLabelTranslations[languagecode].statusQuoted,
    },
    {
      value: "Not Interested",
      label: statusOptionLabelTranslations[languagecode].statusNotInterested,
    },
    {
      value: "Sold",
      label: statusOptionLabelTranslations[languagecode].statusSold,
    },
  ];

  let commonActoinMessageButton = {
    height: "25%",
    marginBottom: "2%",
    marginTop: "6%",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: "17vh",
        paddingTop: "6vh",
        paddingLeft: theme.SCALES.actionPaddingLeft,
        paddingRight: theme.SCALES.actionPaddingRight,
        height: "100%",
      }}
    >
      <ActionCentreText />

      {/* Add Comment Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode].actions.addComments.text}
          buttonText={translations[languagecode].actions.addComments.buttonText}
          buttonClick={() => {
            setModal(true);
            setHideStatus(false);
            setNewStatus(null);
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      {/* Digital Marketing Hub Button */}
      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode].actions.checkInsurerResponses.text}
          buttonText={
            translations[languagecode].actions.checkInsurerResponses.buttonText
          }
          buttonClick={() => {
            dispatch(updateProspectStatus({prospectid, prospectdoc: prospectDetails, statuscode:'app_completed' }))
            setTimeout(() => {
              document.location.href = `/quotes?id=${props.prospectid}`;
            }, 400);
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode].actions.continueAmendProspect.text}
          buttonText={
            translations[languagecode].actions.continueAmendProspect.buttonText
          }
          buttonClick={() => {
            let data = {
              prospectid: prospectid,
              oldstatus: "Continued Quote",
              newstatus: null,
              comment: "Continued Quote",
            };

            dispatch(addTransaction(data)).then(() => {
              document.location.href = `/questions?id=${props.prospectid}`;
            });
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={translations[languagecode].actions.closeProspect.text}
          buttonText={
            translations[languagecode].actions.closeProspect.buttonText
          }
          buttonClick={() => {
            setModal(true);
            setNewStatus("-");
            setHideStatus(true);
            setComment("-");
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        />
      </div>

      <Modal
        size="md"
        isOpen={modalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          justifyContent: "center",
          content: {
            height: "40%",
            width: "16%",
            position: "absolute",
            top: "20%",
            left: "40%",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 10,
            overflow: "hidden",
          },
        }}
      >
        <PerfectScrollbar>
          <div>
            <div style={{ margin: "15px" }}>
              <NormalText>
                {newStatus
                  ? translations[languagecode]?.modal.normalText
                      .selectStatusAndComment ||
                    "Please select a status and enter comment"
                  : translations[languagecode]?.modal.normalText.enterComment ||
                    "Please enter a comment"}
              </NormalText>
            </div>
            {hideStatus ? (
              <div style={{ margin: "10px" }}>
                <FormControl variant="filled" sx={{ m: 0, minWidth: 260 }}>
                  <Select
                    options={statusOptions}
                    placeholder={
                      translations[languagecode]?.modal
                        .selectStatusPlaceholder || "Select a status"
                    }
                    style={{
                      width: "13vw",
                      backgroundColor: "#ffffff",
                      borderRadius: "5px",
                    }}
                    onChange={(e) => {
                      setNewStatus(e[0].value);
                    }}
                  />
                </FormControl>
              </div>
            ) : (
              <div />
            )}
            <div style={{ margin: "10px" }}>
              <FormControl sx={{ m: 0, minWidth: 260 }}>
                <TextareaAutosize
                  id="txtComment"
                  placeholder={
                    translations[languagecode]?.modal.textareaPlaceholder ||
                    "Enter a comment"
                  }
                  style={{
                    backgroundColor: "#ffffff",
                    width: "13vw",
                    height: "18vh",
                  }}
                  className="form-control"
                  onChange={(x) => setComment(x.target.value)}
                />
              </FormControl>
            </div>
            <div className="m-2" style={{ width: "30%", float: "right" }}>
              <ActionButton
                text={
                  translations[languagecode]?.modal.actionButtons.save || "Save"
                }
                onClick={() => {
                  let data = {
                    prospectid: prospectid,
                    oldstatus: prospectDetails.status,
                    newstatus: newStatus === "-" ? null : newStatus,
                    comment: comment === "-" ? null : comment,
                  };
                  if (newStatus?.includes("Close")) {
                    dispatch(
                      updateBmsInfo({
                        action: "close_app",
                        postdata: { newStatus, prospectid },
                      })
                    );
                  }
                  dispatch(addTransaction(data)).then(
                    setTimeout(() => {
                      if (data.newstatus) dispatch(getMyQuotes(null));
                      dispatch(getTransactions(prospectid));
                    }, 100)
                  );
                  setModal(false);
                }}
              />
            </div>
            <div className="m-2" style={{ width: "30%", float: "right" }}>
              <ActionButton
                text={
                  translations[languagecode]?.modal.actionButtons.cancel ||
                  "Cancel"
                }
                onClick={() => setModal(false)}
              />
            </div>
          </div>
        </PerfectScrollbar>
      </Modal>
    </div>
  );
};
//#endregion

export default ProspectZoom;
